import { ExtraTypes } from '@/app/shared/constants/extraTypes';

/**
 * Calculate the membership price by subtracting selected additional items and extras costs
 * @param {Object} basket - The basket object
 * @returns {number} The calculated membership price
 */
export function calculateMembershipPrice(basket) {
  if (!basket) return 0;

  // use this instead of BasePrice to get the membership cost
  return basket.RenewalPrice;
}

/**
 * Calculate the total cost including insurance for Type 7 extras
 * @param {Object} basket - The basket object
 * @returns {number} The total cost with insurance
 */
export function calculateTotalWithInsurance(basket) {
  if (!basket) return 0;

  const membershipPrice = calculateMembershipPrice(basket);

  // Use the discounted price (NewPrice) when available; fall back to BasePrice otherwise
  let total = typeof basket.NewPrice === 'number' ? basket.NewPrice : basket.BasePrice;

  // Add actual insurance cost for Type 7 extras only
  if (basket.AdditionalExtras) {
    basket.AdditionalExtras.forEach((extra) => {
      if (!extra.Selected) return;
      if (extra.Type === ExtraTypes.MEMBERSHIP_INSURANCE) {
        const insuranceCost = extra.Cost * membershipPrice;
        // add insurance cost back to total
        total += insuranceCost;
      }
    });
  }

  // Round to 2 decimal places to avoid floating point precision issues
  return Math.round(total * 100) / 100;
}

/**
 * Calculate the insurance cost for a specific extra
 * @param {Object} extra - The insurance extra object
 * @param {Object} basket - The basket object
 * @returns {number} The calculated insurance cost
 */
export function calculateInsuranceCost(extra, basket) {
  if (!extra || !basket || extra.Type !== ExtraTypes.MEMBERSHIP_INSURANCE) return 0;

  const membershipPrice = calculateMembershipPrice(basket);
  return extra.Cost * membershipPrice;
}
